import { motion } from "framer-motion";

export const Rich = ({ text = "", shimmer = false }) =>
  text.split(/(_[^_]+_)/g).map((part, i) =>
    part.startsWith("_") && part.endsWith("_") ? (
      <em key={i} className={`serif ${shimmer ? "shimmer-accent" : "text-[var(--fux)]"}`}>{part.slice(1, -1)}</em>
    ) : (
      <span key={i}>{part}</span>
    )
  );

export const Reveal = ({ children, delay = 0, y = 40, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, className = "", testid }) => (
  <p data-testid={testid} className={`mono text-[12px] uppercase text-[var(--amber)] flex items-center gap-3 ${className}`}>
    <span className="inline-block w-8 h-px bg-[var(--amber)]" />
    {children}
  </p>
);
